import { queryOptions } from '@tanstack/react-query';
import { api as registrationApi } from '@repo/api-kit/registration';
import { searchOrganization } from '#organizations/queries/search-organization';

const { ApiCustomer: ApiCustomerFromJSON } = registrationApi.customer.firstparty.v1;

const all = ['customer'] as const;

export const customerQueries = {
  all,
  detail: (organizationId: string) =>
    queryOptions({
      queryKey: [...all, organizationId] as const,
      queryFn: async () => {
        const graphqlOrg = await searchOrganization({
          includeFinancialDetail: false,
          organizationId,
        });
        return ApiCustomerFromJSON.fromJSON(graphqlOrg.customer);
      },
      staleTime: Infinity,
      gcTime: Infinity,
    }),
};
